import React, { useState, useEffect } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { IoIosCall } from 'react-icons/io'
import { MdCallEnd, MdDialpad } from 'react-icons/md'
import { AiOutlinePauseCircle, AiOutlinePlayCircle } from 'react-icons/ai'
import { BsMicMuteFill } from 'react-icons/bs'
import { IoPersonSharp } from 'react-icons/io5'
import '../../../styles/components/common/_inBoundCallComponent.scss'
import { holdCall, unholdCall } from '../../../redux/actions/caller'
import { Modal } from 'rsuite'
import { ACCEPT_INCOMING_CALL } from '../../../redux/actionTypes/caller'

const InBoundCallComponent = ({ matchData, show = true, name = '', phoneNo = '', call, vendorId, callerSID, onCallReject, onCallHangup, onAcceptCall }) => {
    var path
    let href = window.location.href.split('lists')[1]

    if (href) {
        var hrefSplit = href.split('/');
        var finalHref = hrefSplit.pop();
        path = hrefSplit.join('/')
    }

    const dialerNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, '*', 0, '#']
    const dispatch = useDispatch()
    const history = useHistory()
    const store = useStore().getState()
    const location = useLocation()
    const {
        caller: { inboundCall, callDuration, twilioDevice },
        auth: { user }
    } = store
    const [phoneNumber, setPhoneNumber] = useState('')
    const [vendorName, setVendorName] = useState('')
    const [callerId, setCallerId] = useState('')
    const [dialerShowClass, setDialerShowClass] = useState('d-none')
    const [isMute, setIsMute] = useState(false)
    const [isPause, setIsPause] = useState(false)
    const [isCallReceived, setIsCallReceived] = useState(false)
    const [incomingCall, setIncomingCall] = useState(null)
    const [duration, setDuration] = useState(0);
    const [callStartTime, setCallStartTime] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isShowAddCallerDetails, setIsShowAddCallerDetails] = useState(false)
    const [isConfirmOrRemoveMatch, setIsConfirmOrRemoveMatch] = useState(false)
    const [matchedSupplier, setMatchedSupplier] = useState([])
    const [showConfirm, setShowConfirm] = useState(false)

    useEffect(() => {
        if (location?.state?.isRedirected) {
            setCallStartTime(callDuration)
            setIsConfirmOrRemoveMatch(true)
            setCallerId(location?.state?.callerId)
        }
        setShowModal(show)
        if (phoneNo) {
            phoneNo = formatPhoneNumber(phoneNo)
        }
        setPhoneNumber(phoneNo)
        setVendorName(name)
        setMatchedSupplier(matchData)
        setCallerId(callerSID)
    }, [])

    useEffect(() => {
        setIncomingCall(inboundCall)
        setPhoneNumber(inboundCall?.parameters?.From)
    }, [inboundCall])

    useEffect(() => {
        if (callStartTime) {
            const intervalId = setInterval(() => {
                // const currentDuration = Math.floor((Date.now() - callStartTime) / 1000);
                const elapsedMilliseconds = Date.now() - callStartTime;
                const totalSeconds = Math.floor(elapsedMilliseconds / 1000);
                const minutes = Math.floor(totalSeconds / 60);
                const seconds = totalSeconds % 60;
                setDuration({ minutes: minutes < 10 ? '0' + minutes : minutes, seconds: seconds < 10 ? '0' + seconds : seconds });
            }, 1000);

            return () => {
                clearInterval(intervalId);
            };
        }
    }, [callStartTime]);

    function formatPhoneNumber(phoneNumber) {
        const cleanNum = phoneNumber.toString().replace(/\D/g, '');
        const match = cleanNum.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
        if (match) {
            return match[1] + '-' + (match[2] ? match[2] + "-" : "") + match[3];
        }
        return cleanNum;
    }

    const handleMuteClick = () => {
        setIsMute(!isMute)
        if (isMute) {
            incomingCall.mute(false);
        } else {
            incomingCall.mute(true);
        }
    }

    function acceptIncomingCall() {
        incomingCall.accept({
            rtcConfiguration: {
                sdpSemantics: 'unified-plan'
            }
            // Other options
        });
        setIsCallReceived(true)
        setDialerShowClass('')
        setCallStartTime(Date.now())
        dispatch({
            type: ACCEPT_INCOMING_CALL,
            data: Date.now()
        })

        if (showModal) {
            setIsShowAddCallerDetails(true)
            history.push({
                pathname: '/lists',
                state: {
                    IsShowAddCallerDetails: true,
                    // call: JSON?.stringify(incomingCall),
                    phoneNumber: phoneNumber
                },
            })
            onAcceptCall()
        }
        //update UI
    }

    // REJECT INCOMING CALL
    function rejectIncomingCall() {
        incomingCall.reject()
        setIsCallReceived(false)
        setCallStartTime(null)
        setIsConfirmOrRemoveMatch(false)
        setDuration(0)
        onCallReject()
    }

    // HANG UP INCOMING CALL
    function hangupIncomingCall(call) {
        incomingCall.disconnect()
        setIsCallReceived(false)
        setCallStartTime(null)
        setDuration(0)
        setIsConfirmOrRemoveMatch(false)
        onCallHangup()
    }

    const handleHoldClick = () => {
        return
        if (isPause) {
            console.log('unhold')
            dispatch(unholdCall())
        } else {
            console.log('hold')
            dispatch(holdCall(callerId))
        }
        setIsPause(!isPause)
    }

    const handleConfirmMatchClick = () => {
        setIsConfirmOrRemoveMatch(true)
        if (showModal) {
            setIsShowAddCallerDetails(true)
            history.push({
                pathname: '/lists',
                state: {
                    IsShowAddCallerDetails: true,
                    matchedSupplier: JSON?.stringify(matchedSupplier),
                    phoneNumber: phoneNumber,
                    vendorId: matchedSupplier?.length ? matchedSupplier?.[0]?.id : null,
                    callerId: callerId
                },
            })
            onAcceptCall()
        }
    }

    const handleRemoveMatchClick = () => {
        setIsConfirmOrRemoveMatch(true)
        if (showModal) {
            setIsShowAddCallerDetails(true)
            history.push({
                pathname: '/lists',
                state: {
                    IsShowAddCallerDetails: true,
                    matchedSupplier: JSON?.stringify([]),
                    phoneNumber: phoneNumber,
                    vendorId: null,
                    callerId: callerId,
                    supName: matchedSupplier?.[0]?.suppliername || ''
                },
            })
            onAcceptCall()
        }
    }

    const handleNumberClick = (value) => {
        if (isCallReceived) {
            var connections = twilioDevice.activeConnection();
            if (connections) {
                connections.sendDigits(value);
            }
            return
        }
    }

    const getModalContent = () => {
        return (
            <div className='call-component inbound-call-component pt-5 pb-5 border rounded position-relative'>
                <div className='d-flex flex-column align-items-center ps-5 pe-5'>
                    <div className='p-3 rounded-circle bg-light-gray'><IoPersonSharp color="#fff" size={40} /></div>
                    <h3 className='text-center text-white mb-0 mt-3 fw-bold'>Incoming Call</h3>
                    <h3 className='text-center text-white mb-0 mt-3 fw-bold text-break'>{vendorName || 'Unknown'}</h3>
                    <h3 className='text-white mb-0 mt-3'>{phoneNumber || '201-987-7865'}</h3>
                    {isCallReceived && (
                        <>
                            {duration ? (
                                <p className='h4 call-timer text-white mb-0 mt-3'> {duration.minutes} : {duration.seconds}</p>
                            ) :
                                <></>
                            }
                            <div className='d-flex mt-3 justify-content-center align-items-center gap-5'>
                                <div className={`p-2 rounded-circle ${isMute ? 'bg-white' : ''}`}>
                                    <BsMicMuteFill color={`${isMute ? '#000' : '#fff'}`} size={25} onClick={() => { handleMuteClick() }} />
                                </div>
                                {isPause ?
                                    <AiOutlinePlayCircle color="#fff" size={25} onClick={() => { handleHoldClick() }} />
                                    :
                                    <AiOutlinePauseCircle color="#fff" size={25} onClick={() => { handleHoldClick() }} />
                                }
                                <MdDialpad color="#fff" size={25} onClick={() => { !dialerShowClass ? setDialerShowClass('d-none') : setDialerShowClass('') }} />
                            </div>
                        </>
                    )}
                    <div className={`d-flex ps-5 pe-5 gap-4 flex-wrap justify-content-center ${dialerShowClass} ${isCallReceived ? 'mt-3' : 'mt-3'}`}>
                        {dialerNumbers.map(value => {
                            return <input style={{ height: '50px', width: '50px' }} className='bg-light-gray text-blue fw-bold h4 mb-0 text-center border-0 rounded-circle' readOnly onClick={(event) => { handleNumberClick(event.target.value) }} value={value} />
                        })}
                    </div>
                </div>

                <div className={`m-3 mt-5 mb-5 d-flex flex-column caller-insights${isCallReceived ? ' d-none' : ' bg-white'} pt-4 pb-4 contact-details`}>
                    <div className='border border-2 border-start-0 border-end-0 border-top-0'>
                        <h1 className='fw-bold text-black text-center mb-4'>Confirm Matching</h1>
                    </div>
                    <div className='p-5 pt-4 pb-4'>
                        <div className='d-flex gap-2 align-items-center'>
                            <h3 className="text-black mb-0 fw-bold w-100">Supplier Name:</h3>
                            <h5 className="mb-0 fw-normal text-blue w-100">
                                {matchedSupplier?.length ? matchedSupplier?.[0]?.suppliername : 'Unknown'}
                            </h5>
                        </div>
                        <div className='d-flex gap-2 mt-2 align-items-center'>
                            <h3 className="text-black mb-0 fw-bold w-100">Supplier Phone:</h3>
                            <h5 className="mb-0 fw-normal text-blue w-100">
                                {matchedSupplier?.length ? matchedSupplier?.[0]?.phone : ''}
                            </h5>
                        </div>
                    </div>
                    {!isConfirmOrRemoveMatch && (
                        <div className='d-flex justify-content-center gap-3 border border-2 border-start-0 border-end-0 border-bottom-0 pt-4'>
                            {matchedSupplier?.length === 0 ?
                                <button type="button" className='p-3 bg-dark-blue text-white fw-bold h4 mb-0 rounded' onClick={() => { handleRemoveMatchClick() }}>Link Later</button>
                                :
                                <>
                                    <button type="button" className='p-3 bg-dark-blue text-white fw-bold h4 mb-0 rounded' onClick={() => { handleRemoveMatchClick() }}>Remove Match</button>
                                    <button type="button" className='p-3 bg-dark-blue text-white fw-bold h4 mb-0 rounded' onClick={() => { handleConfirmMatchClick() }}>Confirm Match</button>
                                </>
                            }
                        </div>
                    )}
                </div>

                <div className='call-buttons position-absolute start-0 end-0 d-flex justify-content-center'>
                    <button id="reject-call" onClick={() => { rejectIncomingCall() }} ><MdCallEnd style={{ background: '#FF0000' }} className={`rounded-circle p-2 mt-4${isCallReceived ? ' d-none' : ''}`} color="#fff" size={50} /></button>
                    {/* {!isCallReceived && ( */}
                    <button id="receive-call" onClick={() => { acceptIncomingCall() }} ><IoIosCall style={{ background: '#198754' }} className={`rounded-circle p-2 mt-4 ms-4${(!isConfirmOrRemoveMatch || isCallReceived) ? ' d-none' : ''}`} color="#fff" size={50} /></button>
                    <button id="end-call" onClick={() => { hangupIncomingCall() }} ><MdCallEnd style={{ background: '#FF0000' }} className={`rounded-circle p-2 mt-4${!isCallReceived ? ' d-none' : ''}`} color="#fff" size={50} /></button>
                    {/* )} */}
                </div>
            </div>
        )
    }

    const hideHandler = () => {
        setShowModal(false)
        setShowConfirm(true)
    }

    const onEndHandler = () => {
        rejectIncomingCall()
        setShowConfirm(false);
    }

    return (
        <>
            {showConfirm && <Modal
                backdrop='static'
                className="inbound-call-modal"
                show={showConfirm}
                size="sm"
            >
                <Modal.Header>
                    <Modal.Title className='text-black'>Confirm End Call?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex column-gap-4 justify-content-center'>
                        <button className='report_button_success' onClick={() => { setShowConfirm(false) }}>Cancel</button>
                        <button className='report_button_danger' onClick={() => { onEndHandler() }}  >End</button>
                    </div>
                </Modal.Body>
            </Modal>}
            {!isShowAddCallerDetails ?
                showModal ? (
                    <Modal
                        backdrop='static'
                        className="inbound-call-modal"
                        show={showModal}
                        size="sm"
                        // onClick={onClose}
                        onHide={() => { hideHandler() }}
                    >
                        <Modal.Header>
                            <Modal.Title className='text-black'>Incoming Call</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {getModalContent()}
                        </Modal.Body>
                    </Modal>
                ) : (
                    getModalContent()
                ) :
                <></>}
        </>
    )
}

export default InBoundCallComponent